export enum DialogAction {
    DELETE = <any>"delete",
    CANCEL =  <any>"cancel",
    MESSAGE = <any>"message",
    YES =  <any>"yes",
    NO =  <any>"no",
    DEACTIVE = <any>"deactive",
    REACTIVE = <any>"delete",
    ACTIVE = <any>"active",
    COPY=<any>"copy",
    UNSUBSCRIBE = <any>"unsubscribe",
    ALERT= <any>"alert",
}
export enum ActionMessage {
    DELETE = <any>"Are you sure want to delete?",
    REACTIVATE=<any>"Are you sure you want to reactivate this corporate account?",
    CANCEL =  <any>"Are you sure want to cancel?",
    LOGINERROR = <any>"Username or Password is wrong",
    SAVESUCCESS = <any>"saved successfully",
    UPDATESUCCESS = <any>"updated successfully",
    COPYSUCCESS = <any>"copied successfully",
    DELETESUCCESS = <any>"deleted successfully",
    DEACTIVATE = <any>"Are you sure want to deactivate?",
    COPY = <any>"Are you sure want to copy?",
    UNSUBSCRIBE = <any>"Are you sure want to unsubscribe?",
}



// WEBPACK FOOTER //
// ./src/app/shared/enum/dialog-action.enum.ts